import './Footer.css'

const Footer = () => {
  return (
    <footer className="footer" role="contentinfo">
      <div className="footer-content">
        <div className="footer-brand">
          {/* Hexagon logo stacked above domain text */}
          <div className="footer-logo-stacked">
            <svg
              className="footer-hexagon-icon"
              viewBox="0 0 100 100"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              {/* Outer hexagon */}
              <polygon points="50,5 93,27.5 93,72.5 50,95 7,72.5 7,27.5" />
              {/* Inner triangles - 6 lines from vertices to center */}
              <line x1="50" y1="5" x2="50" y2="50" />
              <line x1="93" y1="27.5" x2="50" y2="50" />
              <line x1="93" y1="72.5" x2="50" y2="50" />
              <line x1="50" y1="95" x2="50" y2="50" />
              <line x1="7" y1="72.5" x2="50" y2="50" />
              <line x1="7" y1="27.5" x2="50" y2="50" />
            </svg>
            <span className="footer-domain">fantomize.com</span>
          </div>
          <p className="footer-tagline">Luxury fashion at your fingertips</p>
        </div>
        
        <div className="footer-links">
          <div className="footer-column">
            <h4>Product</h4>
            <ul>
              <li><a href="/#features">Features</a></li>
              <li><a href="/search">Search</a></li>
            </ul>
          </div>
          
          <div className="footer-column">
            <h4>Company</h4>
            <ul>
              <li><a href="/blog">Blog</a></li>
              <li><a href="/partner/apply" className="footer-partner-link">Become a Partner</a></li>
            </ul>
          </div>
        </div>
      </div>
      
      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Fantomize. All rights reserved.</p>
      </div>
    </footer>
  )
}

export default Footer

